import 'css-chunksrc/client/scenes/workloads/wbs/task/allocationsList/details/group/styles.scss';export default {
  "group": "_group_1xjvi_1",
  "removeAllocation": "_removeAllocation_1xjvi_12",
  "resource": "_resource_1xjvi_16",
  "container": "_container_1xjvi_24",
  "label": "_label_1xjvi_32",
  "center": "_center_1xjvi_38",
  "avatar": "_avatar_1xjvi_42",
  "user": "_user_1xjvi_52",
  "name": "_name_1xjvi_59",
  "title": "_title_1xjvi_65",
  "allocatedHours": "_allocatedHours_1xjvi_70",
  "completionCheck": "_completionCheck_1xjvi_87",
  "icon": "_icon_1xjvi_99"
};